import { Injectable } from '@angular/core';
import { AccountsService } from '../accounts/accounts.service';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { UsersService } from '../users/users.service';
import { CigpStaffService } from '../cigp-staff/cigp-staff.service';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { ROLE_COMPLIANCE } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class UpdateDataService {
  public accountsSet$ = new BehaviorSubject<boolean>(false);
  public staffsSet$ = new BehaviorSubject<boolean>(false);
  public usersSet$ = new BehaviorSubject<boolean>(false);

  constructor(
    private accountsService: AccountsService,
    private usersService: UsersService,
    private cigpStaffService: CigpStaffService,
    private logger: NGXLogger,
    private authService: EaccessAuthService
  ) {}

  public loadDataAtStartup(): void {
    this.authService.hasRole$(ROLE_COMPLIANCE).subscribe((hasComplianceRole) => {
      if (hasComplianceRole) {
        this.logger.log('User has compliance role, loading data at startup');
        this.loadDataForComplianceRole();
      } else {
        this.logger.log('User does not have compliance role, skipping data load at startup');

        this.accountsService.accountsSet$.next(true);
        this.accountsSet$.next(true);

        this.usersService.usersSet$.next(true);
        this.usersSet$.next(true);

        this.cigpStaffService.staffsSet$.next(true);
        this.staffsSet$.next(true);
      }
    });
  }

  private loadDataForComplianceRole(): void {
    this.logger.log('Starting to load accounts, users, and staffs at startup');
    this.accountsService
      .loadAccountsFromCacheAndRefreshIfNeeded$()
      .pipe(
        tap((accounts) => {
          this.logger.log(`Finished loading ${accounts?.length || '0'} accounts`);
          this.accountsSet$.next(true);
        }),
        switchMap(() => this.usersService.loadUsersFromCacheAndRefreshIfNeeded$()),
        tap((users) => {
          this.logger.log(`Finished loading ${users?.length || '0'} users`);
          this.usersSet$.next(true);
        }),
        switchMap(() => this.cigpStaffService.loadCigpStaffsFromCacheAndRefreshIfNeeded$()),
        tap((staffs) => {
          this.logger.log(`Finished loading ${staffs?.length || '0'} staffs`);
          this.staffsSet$.next(true);
        })
      )
      .subscribe();
  }
}
